import type { FlagName } from '../../utils/featureFlags';

import { signaler } from '@/utils/signaler';

export const useFeatureFlagEnabled = (flag: FlagName) => {
  const flagKey = signaler.featureFlag(flag);
  return flagKey === 'test';
};
